var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowPrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0001 0.366969C32.0001 0.128901 31.7182 0.00319554 31.5411 0.162268L5.22801 23.7941C5.10629 23.9034 5.10629 24.0942 5.22801 24.2035L31.5411 47.8353C31.7182 47.9943 32.0001 47.8686 32.0001 47.6306L32.0001 33.6505C32.0001 33.5707 31.9654 33.4948 31.9051 33.4425L21.2403 24.2065C21.1136 24.0968 21.1136 23.9003 21.2403 23.7906L31.9051 14.5545C31.9654 14.5023 32.0001 14.4264 32.0001 14.3466L32.0001 0.366969Z",
    fill: "#004B8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2887 24.2333C31.1401 24.1132 31.1401 23.8868 31.2887 23.7667L38.0114 18.3327C38.2076 18.1742 38.5 18.3138 38.5 18.5661L38.5 29.4339C38.5 29.6862 38.2076 29.8258 38.0114 29.6673L31.2887 24.2333Z",
    fill: "#004B8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowPrev);
export default __webpack_public_path__ + "static/media/arrow_prev.5d919f696db3dd225556739dd58d19a4.svg";
export { ForwardRef as ReactComponent };